import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";

const ExcelReport = ({ data, columns, filename, customStyle }) => {
  const dispatch = useDispatch();
  const handleDownload = async () => {
    if (!Array.isArray(columns) || columns.length === 0) {
      console.error("Columns are not defined or are empty!");
      return;
    }

    if (
      !data ||
      (Array.isArray(data) && data.length === 0) ||
      (typeof data === "object" && !Object.keys(data).length)
    ) {
      console.error("Data is not defined or is empty!");
      dispatch(
        showToast({
          message:
            "Select Atleast One Data" || "Data is not defined or is empty!",
          type: "error",
        })
      );
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(filename);

      // Set the title on row 1, merged across all columns
      worksheet.mergeCells("A1:F1");
      const titleRow = worksheet.getRow(1);
      titleRow.getCell(1).value = "Report - Score Board";
      titleRow.getCell(1).font = {
        bold: true,
        size: 14,
        color: { argb: "FFFFFFFF" },
      };
      titleRow.getCell(1).alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      titleRow.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF305496" },
      };

      titleRow.height = 30;

      worksheet.columns = columns.map((col) => ({
        header: col.header,
        key: col.key,
        width: col.width || 20,
      }));

      const headerRow = worksheet.getRow(2);
      columns.forEach((col, index) => {
        headerRow.getCell(index + 1).value = col.header;
      });
      headerRow.getCell(2).alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      headerRow.height = 25;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin", color: { argb: "FF000000" } },
          left: { style: "thin", color: { argb: "FF000000" } },
          bottom: { style: "thin", color: { argb: "FF000000" } },
          right: { style: "thin", color: { argb: "FF000000" } },
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFB4C6E7" },
        };
      });

      const dataArray = Array.isArray(data) ? data : [data];

      const rowData = dataArray.map((item, index) => {
        return {
          col1: index + 1,
          col2: item?.personName || "Unknown",
          col3: item?.projectShortName || "Unknown",
          col4: item?.sendAt || "N/A",
          col5: item?.typeChoosen || "NA",
          col6: item?.totalScore || 0,
        };
      });

      rowData.forEach((rowDataItem) => {
        const row = worksheet.addRow(rowDataItem);
        row.height = 20;
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin", color: { argb: "FF000000" } },
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
          };
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        //   // Add styling for the "excelFileView" column (if it exists in the data)
        if (rowDataItem?.excelFileView) {
          row.getCell("excelFileView").style.font = {
            color: { argb: "FF0000FF" },
            underline: true,
          };
        }
      });

      // Generate the Excel file buffer and save it
      titleRow.getCell(1).value = "Report - Score Board";
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${filename}.xlsx`);
    } catch (error) {
      console.error("Error downloading the Excel file", error);
    }
  };

  return (
    <Button
      className={customStyle ? "addButton" : "download-excel-btn"}
      onClick={handleDownload}
      sx={{ height: "100%" }}
    >
      Download Excel
    </Button>
  );
};

export { ExcelReport };
